<template>
  <div class="text-app-color">
    <p class="text-19 font-semibold mb-20">Comments</p>
    <!-- @scroll="scrollListener" -->
    <div v-if="messages.length" ref="scrollToDownRef">
      <!-- C A R D -->
      <TaskChatMessage
        v-for="(message, index) in messages"
        :key="message.id"
        :message="message"
        :class="{'mt-10': index !== 0}"
      />
    </div>

    <div class="-mx-15 md:mx-0 flex mt-20">
      <div class="hidden md:block flex-shrink-0 text-grey-300 text-15 mr-20">
        <div class="text-app-color rounded-6 py-3 px-10 w-110"
             :class="isDarkMode ? 'bg-book' : 'bg-white shadow-user-badge border border-grey-500'"
        >
          <UserBadge
            :first-name="user.profile.firstName"
            :last-name="user.profile.lastName"
            :color="user.profile.color"
            color-height="h-18"
            max-width="max-w-80"
          />
        </div>
        <p class="text-13 text-grey-250 text-right">now</p>
      </div>
      <TaskChatEditor :allow-hot-key="allowHotKey" :task="task" @scroll-to-down="scrollToElement" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref, onMounted, nextTick } from 'vue'

import { useStore } from 'vuex'
import TaskChatMessage from '@/components/task-board/TaskChatMessage'
import TaskChatEditor from '@/components/task-board/TaskChatEditor'

export default defineComponent({
  name: 'TaskChat',

  components: {
    TaskChatMessage,
    TaskChatEditor
  },

  props: {
    task: Object,
    allowHotKey: Boolean
  },

  setup (props, { emit }) {
    const { state, dispatch, getters } = useStore()

    const user = computed(() => state.profile.user)

    const scrollToDownRef = ref(null)

    const messages = computed(() => state.chat.taskMessages)
    const countMessages = computed(() => props.task.chat?.messages?.length || 0)
    const messageCount = computed(() => messages.value.length)
    const isDarkMode = computed(() => getters.isDarkMode)

    onMounted(async () => {
      scrollToElement()
    })

    function scrollToElement () {
      nextTick(() => {
        if (scrollToDownRef.value) {
          scrollToDownRef.value.scrollTop = scrollToDownRef.value.scrollHeight
        }
      })
    }

    const isFetchingMessagesAllowed = ref(true)
    const previousScrollTop = ref(0)
    let page = 1

    function scrollListener (e) {
      const top = e.target.scrollTop < 0 ? e.target.scrollHeight + e.target.scrollTop - e.target.clientHeight : e.target.scrollTop

      if (messages.value.length >= countMessages.value) {
        isFetchingMessagesAllowed.value = false
      }

      if (isFetchingMessagesAllowed.value && previousScrollTop.value > top && top < 100 && top >= 50) {
        isFetchingMessagesAllowed.value = false

        dispatch('fetchTaskMessages', {
          chatId: props.task.chat.id,
          bookId: props.task.bookId,
          page: page
        }).then(() => {
          page++
          setTimeout(() => {
            isFetchingMessagesAllowed.value = true
          }, 1000)
        })
      }

      previousScrollTop.value = top
    }

    return {
      // refs
      scrollToDownRef,
      // data
      messages,
      // computed
      user,
      isDarkMode,
      messageCount,
      countMessages,
      // function
      close,
      scrollListener,
      scrollToElement
    }
  }
})
</script>
